import React from 'react';

const CoolCliInputPage = () => {
  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Crates.io Registry</div>
          <h1 className="page-title">cool_cli_input</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            An intuitive, feature-rich Rust CLI input utility. It allows users to enter standard inline input, with a special power: typing <strong style={{ color: 'var(--accent)' }}>"vim"</strong> automatically launches their default system editor (falling back to <code>vim</code>) to comfortably write longer multi-line text and commit it seamlessly.
          </p>
        </section>

        <div className="section-stack">
          <section className="section-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.2rem' }}>
              <div>
                <div className="eyebrow">Crate</div>
                <h2 className="page-title" style={{ fontSize: '2.2rem', marginBottom: '0.25rem' }}>cool_cli_input</h2>
                <p className="page-subtitle" style={{ fontSize: '1.05rem', margin: 0 }}>
                  Seamless inline CLI input with instant external editor invocation for extended multi-line thoughts.
                </p>
              </div>
              <a
                className="button-link"
                href="https://crates.io/crates/cool_cli_input"
                target="_blank"
                rel="noopener noreferrer"
                style={{ height: 'fit-content' }}
              >
                View on Crates.io
              </a>
            </div>

            <div className="terminal-line" style={{ display: 'flex', width: '100%', boxSizing: 'border-box', marginTop: '1rem' }}>
              <span style={{ color: 'var(--accent)', marginRight: '0.5rem' }}>$</span>
              <span>cargo install cool_cli_input</span>
            </div>
          </section>

          <div className="two-column-grid">
            <section className="section-card">
              <h3 className="section-title">Key Features</h3>
              <ul className="bullet-list">
                <li>Standard prompt handling for quick, one-line terminal inputs.</li>
                <li><strong>Vim Integration:</strong> Type <code>"vim"</code> at the prompt to instantly spawn your preferred editor ($EDITOR or fallback to vim) for rich multi-line message composing.</li>
                <li>Robust error handling and safe temporary file cleanup.</li>
                <li>Clean Rust API designed for easy drop-in integration into any CLI application.</li>
              </ul>
            </section>

            <section className="section-card">
              <h3 className="section-title">How It Works</h3>
              <p className="page-copy">
                In your Rust CLI program, prompt your users effortlessly:
              </p>
              <div className="terminal-line" style={{ display: 'flex', width: '100%', boxSizing: 'border-box' }}>
                <span style={{ color: 'var(--accent)', marginRight: '0.5rem' }}>$</span>
                <span>{`let input = cool_cli_input::get_input("Enter message: ");`}</span>
              </div>
              <p className="page-copy" style={{ marginTop: '1rem', marginBottom: 0 }}>
                When the user types <code>vim</code>, <code>cool_cli_input</code> spins up a temp file, opens <code>$EDITOR</code> (or vim), waits for you to save and exit, and reads the resulting text back into your program automatically.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoolCliInputPage;
